<template>
  <el-dialog
    width="446px"
    title="认证失败"
    @close='editEmail'
    :top="top"
    :visible="true"
    :show-close="true"
    :close-on-click-modal="false">
    <span class="color_60 f_14 lh20">请使用正规邮箱进行员工身份的认证，或者通过上传营业执照进行认证</span>
    <span slot="footer" class="dialog-footer">
      <button class="cancel" @click="editEmail">修改邮箱</button>
      <button class="bg_current border_current confirm btn-padding" type="primary" @click="toCompanyAudit">上传营业执照</button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name:'error',
  props: {
    email: String,
    top: {
      type: String,
      default: '300px'
    }
  },
  data(){
    return {
    }
  },
  created(){
    console.log(this.isShow);
    this.sMessageBoxState = this.isShow
  },
  methods: {
    // 去公司审核
    toCompanyAudit(){
      let { href } = this.$router.resolve({
        path: '/talent/binduser',
        query: {fromEditUserInfo: true, bindCompany: true, email: encodeURIComponent(this.email)}
      })
      this.$emit('toAudit')
      window.open(href,'_blank')
    },
    editEmail(){
      this.$emit('editEmail')
    }
  }
}
</script>

<style scoped lang='scss'>
  .lh20{
    line-height: 20px;
  }
  .btn-padding{
    padding: 0 8px;
    box-sizing: content-box;
  }
  button {
    line-height: 36px;
    text-align: center;
    padding: 0;
    width: 84px;
    height: 36px;
    border-radius: 2px;
    box-sizing: border-box;
    &.cancel {
      color: #606060;
      border: 1px solid #D9D9D9;
      background-color: #ffffff;
      margin-right: 16px;
      line-height: 34px;
      &:hover {
        color: #606060;
        opacity: 0.8;
      }
    }
    &.confirm {
      color: #FFFFFF;
      &:hover {
        opacity: 0.8;
      }
    }
  }
</style>
